import { Chip } from '@mui/material';
import { useMemo } from 'react';

import type { HpgMuestraFormValues } from '../schemas';

interface HpgPromedioBadgeProps {
  muestras: HpgMuestraFormValues[];
}

export function HpgPromedioBadge({ muestras }: HpgPromedioBadgeProps): JSX.Element {
  const promedio = useMemo(() => {
    const validas = muestras.filter((m) => m.valor !== null && m.valor !== undefined);
    if (validas.length === 0) return null;
    const sum = validas.reduce((acc, m) => acc + (m.valor ?? 0), 0);
    return Math.round(sum / validas.length);
  }, [muestras]);

  if (promedio === null) {
    return <Chip label="Promedio: —" size="small" variant="outlined" />;
  }

  return <Chip label={`Promedio: ${promedio} HPG`} size="small" color="success" />;
}
